import Suomalainen from "../assets/images/items/suomalainen.png"
import Suomenruotsalainen from "../assets/images/items/suomenruotsalainen.png"

export type CapType = {
  [key: string]: {
    title: string
    img?: string
    sizes: {
      [key: string]: number
    }
  }
}

export const schoolCaps: CapType = {
  SuomalainenCap: {
    img: Suomalainen,
    title: "SUOMALAINEN YLIOPPILASLAKKI",
    sizes:{
      "52" : 0, "53" : 0, "54": 0, "55": 0, "56": 0, "57": 0, "58": 0, "59": 0, "60": 0, "61": 0, "62": 0, "63": 0, "64": 0, "65": 0}
  },
  SuomenruotsalainenCap: {
    img: Suomenruotsalainen,
    title: "SUOMENRUOTSALAINEN / FINLANDSSVENSK",
    sizes: {
      "52" : 0, "53" : 0, "54": 0, "55": 0, "56": 0, "57": 0, "58": 0, "59": 0, "60": 0, "61": 0, "62": 0, "63": 0, "64": 0, "65": 0
    }
  }
}